import { Question } from '../types';

export const objectsQuestions: Question[] = [
  {
    id: 'obj1',
    text: 'According to Al-Ajrumiyyah, what is المفعول به (the direct object)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The noun that performs the action', isCorrect: false },
      { id: 'b', text: 'The noun upon which the action falls', isCorrect: true },
      { id: 'c', text: 'The noun that indicates when the action takes place', isCorrect: false },
      { id: 'd', text: 'The noun that indicates where the action takes place', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines المفعول به (the direct object) as the noun upon which the action falls, as in ضرب زيدٌ عمراً (Zayd hit Amr), where عمراً is the direct object.',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj2',
    text: 'According to Al-Ajrumiyyah, what is the case of المفعول به (the direct object)?',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that المفعول به (the direct object) is always منصوب (accusative).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj3',
    text: 'According to Al-Ajrumiyyah, what are the types of المفعول به (the direct object)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'ظاهر (apparent)', isCorrect: true },
      { id: 'b', text: 'مضمر (pronoun)', isCorrect: true },
      { id: 'c', text: 'مقدم (advanced)', isCorrect: false },
      { id: 'd', text: 'مؤخر (delayed)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the types of المفعول به (the direct object) are: ظاهر (apparent) and مضمر (pronoun).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj4',
    text: 'According to Al-Ajrumiyyah, what is an example of المفعول به الظاهر (the apparent direct object)?',
    type: 'single',
    options: [
      { id: 'a', text: 'ضربتُ زيداً (I hit Zayd)', isCorrect: true },
      { id: 'b', text: 'ضربتُكَ (I hit you)', isCorrect: false },
      { id: 'c', text: 'ضربتُ (I hit)', isCorrect: false },
      { id: 'd', text: 'ضربتُ نفسي (I hit myself)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah gives examples of المفعول به الظاهر (the apparent direct object) such as ضربتُ زيداً (I hit Zayd), where زيداً is the apparent direct object.',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj5',
    text: 'According to Al-Ajrumiyyah, what is an example of المفعول به المضمر (the pronoun direct object)?',
    type: 'single',
    options: [
      { id: 'a', text: 'ضربتُ زيداً (I hit Zayd)', isCorrect: false },
      { id: 'b', text: 'ضربتُكَ (I hit you)', isCorrect: true },
      { id: 'c', text: 'ضربتُ (I hit)', isCorrect: false },
      { id: 'd', text: 'ضربتُ نفسي (I hit myself)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah gives examples of المفعول به المضمر (the pronoun direct object) such as ضربتُكَ (I hit you), where كَ is the pronoun direct object.',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj6',
    text: 'According to Al-Ajrumiyyah, what is المفعول المطلق (the absolute object)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The verbal noun of the verb mentioned in the sentence', isCorrect: true },
      { id: 'b', text: 'The noun upon which the action falls', isCorrect: false },
      { id: 'c', text: 'The noun that indicates when the action takes place', isCorrect: false },
      { id: 'd', text: 'The noun that indicates where the action takes place', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines المفعول المطلق (the absolute object) as the verbal noun of the verb mentioned in the sentence, as in ضربتُ ضرباً (I hit a hitting).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj7',
    text: 'According to Al-Ajrumiyyah, what is the case of المفعول المطلق (the absolute object)?',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that المفعول المطلق (the absolute object) is always منصوب (accusative).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj8',
    text: 'According to Al-Ajrumiyyah, what are the types of المفعول المطلق (the absolute object)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'To emphasize the action (لتأكيد الفعل)', isCorrect: true },
      { id: 'b', text: 'To indicate the type of action (لبيان نوعه)', isCorrect: true },
      { id: 'c', text: 'To indicate the number of times the action is performed (لبيان عدده)', isCorrect: true },
      { id: 'd', text: 'To indicate the place of the action (لبيان مكانه)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the types of المفعول المطلق (the absolute object) are: to emphasize the action, to indicate the type of action, and to indicate the number of times the action is performed.',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj9',
    text: 'According to Al-Ajrumiyyah, what is an example of المفعول المطلق (the absolute object) used to emphasize the action?',
    type: 'single',
    options: [
      { id: 'a', text: 'ضربتُ ضرباً (I hit a hitting)', isCorrect: true },
      { id: 'b', text: 'ضربتُ ضرباً شديداً (I hit a severe hitting)', isCorrect: false },
      { id: 'c', text: 'ضربتُ ضربتين (I hit twice)', isCorrect: false },
      { id: 'd', text: 'ضربتُ زيداً (I hit Zayd)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah gives examples of المفعول المطلق (the absolute object) used to emphasize the action such as ضربتُ ضرباً (I hit a hitting).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj10',
    text: 'According to Al-Ajrumiyyah, what is an example of المفعول المطلق (the absolute object) used to indicate the type of action?',
    type: 'single',
    options: [
      { id: 'a', text: 'ضربتُ ضرباً (I hit a hitting)', isCorrect: false },
      { id: 'b', text: 'ضربتُ ضرباً شديداً (I hit a severe hitting)', isCorrect: true },
      { id: 'c', text: 'ضربتُ ضربتين (I hit twice)', isCorrect: false },
      { id: 'd', text: 'ضربتُ زيداً (I hit Zayd)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah gives examples of المفعول المطلق (the absolute object) used to indicate the type of action such as ضربتُ ضرباً شديداً (I hit a severe hitting).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj11',
    text: 'According to Al-Ajrumiyyah, what is an example of المفعول المطلق (the absolute object) used to indicate the number of times the action is performed?',
    type: 'single',
    options: [
      { id: 'a', text: 'ضربتُ ضرباً (I hit a hitting)', isCorrect: false },
      { id: 'b', text: 'ضربتُ ضرباً شديداً (I hit a severe hitting)', isCorrect: false },
      { id: 'c', text: 'ضربتُ ضربتين (I hit twice)', isCorrect: true },
      { id: 'd', text: 'ضربتُ زيداً (I hit Zayd)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah gives examples of المفعول المطلق (the absolute object) used to indicate the number of times the action is performed such as ضربتُ ضربتين (I hit twice).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj12',
    text: 'According to Al-Ajrumiyyah, what is المفعول فيه (the adverbial object)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The noun that indicates the time or place of the action', isCorrect: true },
      { id: 'b', text: 'The noun upon which the action falls', isCorrect: false },
      { id: 'c', text: 'The verbal noun of the verb mentioned in the sentence', isCorrect: false },
      { id: 'd', text: 'The noun that indicates the reason for the action', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines المفعول فيه (the adverbial object) as the noun that indicates the time or place of the action, also known as ظرف الزمان (adverb of time) and ظرف المكان (adverb of place).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj13',
    text: 'According to Al-Ajrumiyyah, what is the case of المفعول فيه (the adverbial object)?',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that المفعول فيه (the adverbial object) is always منصوب (accusative).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj14',
    text: 'According to Al-Ajrumiyyah, what are examples of ظرف الزمان (adverb of time)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'اليوم (today)', isCorrect: true },
      { id: 'b', text: 'الليلة (tonight)', isCorrect: true },
      { id: 'c', text: 'غداً (tomorrow)', isCorrect: true },
      { id: 'd', text: 'أمام (in front of)', isCorrect: false },
      { id: 'e', text: 'خلف (behind)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions examples of ظرف الزمان (adverb of time) including اليوم (today), الليلة (tonight), and غداً (tomorrow).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj15',
    text: 'According to Al-Ajrumiyyah, what are examples of ظرف المكان (adverb of place)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'أمام (in front of)', isCorrect: true },
      { id: 'b', text: 'خلف (behind)', isCorrect: true },
      { id: 'c', text: 'فوق (above)', isCorrect: true },
      { id: 'd', text: 'تحت (below)', isCorrect: true },
      { id: 'e', text: 'اليوم (today)', isCorrect: false },
      { id: 'f', text: 'الليلة (tonight)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions examples of ظرف المكان (adverb of place) including أمام (in front of), خلف (behind), فوق (above), and تحت (below).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj16',
    text: 'According to Al-Ajrumiyyah, what is المفعول له (the causative object)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The noun that indicates the reason for the action', isCorrect: true },
      { id: 'b', text: 'The noun upon which the action falls', isCorrect: false },
      { id: 'c', text: 'The noun that indicates the time or place of the action', isCorrect: false },
      { id: 'd', text: 'The verbal noun of the verb mentioned in the sentence', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines المفعول له (the causative object) as the noun that indicates the reason for the action, as in قمتُ إجلالاً لزيد (I stood out of respect for Zayd).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj17',
    text: 'According to Al-Ajrumiyyah, what is the case of المفعول له (the causative object)?',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that المفعول له (the causative object) is always منصوب (accusative).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj18',
    text: 'According to Al-Ajrumiyyah, what are the conditions for المفعول له (the causative object)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'It must be a verbal noun (مصدر)', isCorrect: true },
      { id: 'b', text: 'It must indicate the reason for the action', isCorrect: true },
      { id: 'c', text: 'It must share the same time as the action', isCorrect: true },
      { id: 'd', text: 'It must share the same subject as the action', isCorrect: true },
      { id: 'e', text: 'It must be a proper noun (اسم علم)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the conditions for المفعول له are: it must be a verbal noun, it must indicate the reason for the action, it must share the same time as the action, and it must share the same subject as the action.',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj19',
    text: 'According to Al-Ajrumiyyah, what is المفعول معه (the object of accompaniment)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The noun that comes after واو المعية (the waw of accompaniment) to indicate accompaniment', isCorrect: true },
      { id: 'b', text: 'The noun upon which the action falls', isCorrect: false },
      { id: 'c', text: 'The noun that indicates the time or place of the action', isCorrect: false },
      { id: 'd', text: 'The noun that indicates the reason for the action', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines المفعول معه (the object of accompaniment) as the noun that comes after واو المعية (the waw of accompaniment) to indicate accompaniment, as in جاء الأميرُ والجيشَ (The prince came with the army).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj20',
    text: 'According to Al-Ajrumiyyah, what is the case of المفعول معه (the object of accompaniment)?',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that المفعول معه (the object of accompaniment) is always منصوب (accusative).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj21',
    text: 'According to Al-Ajrumiyyah, how is واو المعية (the waw of accompaniment) different from واو العطف (the waw of conjunction)?',
    type: 'single',
    options: [
      { id: 'a', text: 'واو المعية means "with" while واو العطف means "and"', isCorrect: true },
      { id: 'b', text: 'واو المعية connects two nouns while واو العطف connects two verbs', isCorrect: false },
      { id: 'c', text: 'واو المعية is followed by a verb while واو العطف is followed by a noun', isCorrect: false },
      { id: 'd', text: 'There is no difference between them', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah explains that واو المعية means "with" and indicates accompaniment, while واو العطف means "and" and indicates conjunction.',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj22',
    text: 'According to Al-Ajrumiyyah, what is الحال (the circumstantial accusative)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The noun that describes the state of the subject or object when the action takes place', isCorrect: true },
      { id: 'b', text: 'The noun upon which the action falls', isCorrect: false },
      { id: 'c', text: 'The noun that indicates the time or place of the action', isCorrect: false },
      { id: 'd', text: 'The noun that indicates the reason for the action', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines الحال (the circumstantial accusative) as the noun that describes the state of the subject or object when the action takes place, as in جاء زيدٌ راكباً (Zayd came riding).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj23',
    text: 'According to Al-Ajrumiyyah, what is the case of الحال (the circumstantial accusative)?',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that الحال (the circumstantial accusative) is always منصوب (accusative).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj24',
    text: 'According to Al-Ajrumiyyah, what is صاحب الحال (the possessor of the circumstantial accusative)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The person or thing whose state is being described by الحال', isCorrect: true },
      { id: 'b', text: 'The noun upon which the action falls', isCorrect: false },
      { id: 'c', text: 'The noun that indicates the time or place of the action', isCorrect: false },
      { id: 'd', text: 'The noun that indicates the reason for the action', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines صاحب الحال (the possessor of the circumstantial accusative) as the person or thing whose state is being described by الحال, as in جاء زيدٌ راكباً (Zayd came riding), where زيدٌ is صاحب الحال.',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj25',
    text: 'According to Al-Ajrumiyyah, what are the conditions of الحال (the circumstantial accusative)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'It must be نكرة (indefinite)', isCorrect: true },
      { id: 'b', text: 'It must be مشتق (derived)', isCorrect: true },
      { id: 'c', text: 'It must be منصوب (accusative)', isCorrect: true },
      { id: 'd', text: 'It must be معرفة (definite)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the conditions of الحال are: it must be نكرة (indefinite), it must be مشتق (derived), and it must be منصوب (accusative).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj26',
    text: 'According to Al-Ajrumiyyah, what is التمييز (the specificative)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The noun that removes ambiguity from a preceding noun or sentence', isCorrect: true },
      { id: 'b', text: 'The noun upon which the action falls', isCorrect: false },
      { id: 'c', text: 'The noun that indicates the time or place of the action', isCorrect: false },
      { id: 'd', text: 'The noun that indicates the reason for the action', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines التمييز (the specificative) as the noun that removes ambiguity from a preceding noun or sentence, as in اشتريتُ عشرين كتاباً (I bought twenty books), where كتاباً removes the ambiguity from عشرين.',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj27',
    text: 'According to Al-Ajrumiyyah, what is the case of التمييز (the specificative)?',
    type: 'single',
    options: [
      { id: 'a', text: 'مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'منصوب (accusative)', isCorrect: true },
      { id: 'c', text: 'مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah states that التمييز (the specificative) is always منصوب (accusative).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj28',
    text: 'According to Al-Ajrumiyyah, what are the types of التمييز (the specificative)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'تمييز الذات (specificative of essence)', isCorrect: true },
      { id: 'b', text: 'تمييز النسبة (specificative of relation)', isCorrect: true },
      { id: 'c', text: 'تمييز الزمان (specificative of time)', isCorrect: false },
      { id: 'd', text: 'تمييز المكان (specificative of place)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the types of التمييز are: تمييز الذات (specificative of essence) and تمييز النسبة (specificative of relation).',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj29',
    text: 'According to Al-Ajrumiyyah, what is an example of تمييز الذات (specificative of essence)?',
    type: 'single',
    options: [
      { id: 'a', text: 'اشتريتُ عشرين كتاباً (I bought twenty books)', isCorrect: true },
      { id: 'b', text: 'طاب زيدٌ نفساً (Zayd became happy)', isCorrect: false },
      { id: 'c', text: 'ازداد محمدٌ علماً (Muhammad increased in knowledge)', isCorrect: false },
      { id: 'd', text: 'امتلأ الإناءُ ماءً (The vessel became filled with water)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah gives examples of تمييز الذات (specificative of essence) such as اشتريتُ عشرين كتاباً (I bought twenty books), where كتاباً specifies the essence of عشرين.',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  },
  {
    id: 'obj30',
    text: 'According to Al-Ajrumiyyah, what is an example of تمييز النسبة (specificative of relation)?',
    type: 'single',
    options: [
      { id: 'a', text: 'اشتريتُ عشرين كتاباً (I bought twenty books)', isCorrect: false },
      { id: 'b', text: 'طاب زيدٌ نفساً (Zayd became happy)', isCorrect: true },
      { id: 'c', text: 'عندي راقود خلاً (I have a container of vinegar)', isCorrect: false },
      { id: 'd', text: 'عندي شبر أرضاً (I have a span of land)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah gives examples of تمييز النسبة (specificative of relation) such as طاب زيدٌ نفساً (Zayd became happy), where نفساً specifies the relation of طيب (goodness) to زيد.',
    ajrumiyyahReference: 'Chapter on Objects (باب المفعول به)',
    topic: 'objects'
  }
];

